/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Dumbbell = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M14.4 14.4 9.6 9.6" }],
    [
      "path",
      {
        d: "M18.657 21.485a2 2 0 1 1-2.829-2.828l-1.767 1.768a2 2 0 1 1-2.829-2.829l6.364-6.364a2 2 0 1 1 2.829 2.829l-1.768 1.767a2 2 0 1 1 2.828 2.829z"
      }
    ],
    ["path", { d: "m21.5 21.5-1.4-1.4" }],
    ["path", { d: "M3.9 3.9 2.5 2.5" }],
    [
      "path",
      {
        d: "M6.404 12.768a2 2 0 1 1-2.829-2.829l1.768-1.767a2 2 0 1 1-2.828-2.829l2.828-2.828a2 2 0 1 1 2.829 2.828l1.767-1.768a2 2 0 1 1 2.829 2.829z"
      }
    ]
  ]
];

export { Dumbbell as default };
//# sourceMappingURL=dumbbell.js.map
